/** App routes that must work without login (shared recording links, etc.). */
export function isPublicRecordingPath(pathname: string): boolean {
  return pathname === '/recording' || pathname.startsWith('/recording/')
}

/** CLI browser login pages (localhost callback + device code). */
export function isCliAuthPath(pathname: string): boolean {
  return pathname === '/cli/auth' || pathname === '/cli/login' || pathname === '/cli/device'
}

/** Public routes that should not trigger session-expired toasts. */
export function isPublicAuthPath(pathname: string): boolean {
  return (
    pathname === '/login' ||
    pathname === '/join' ||
    pathname === '/auth-bridge' ||
    isPublicRecordingPath(pathname)
  )
}

/** Legal / auth routes reachable before the user accepts current terms. */
export function isTermsExemptPath(pathname: string): boolean {
  return (
    pathname === '/tos' ||
    pathname === '/privacy' ||
    isPublicAuthPath(pathname)
  )
}

export function needsTermsAcceptance(
  user: { terms_accepted?: boolean } | null | undefined,
  pathname: string,
): boolean {
  return Boolean(user && !user.terms_accepted && !isTermsExemptPath(pathname))
}

export function termsRedirectPath(search = ''): string {
  return search ? `/tos${search}` : '/tos'
}

/** Where to send a signed-in user when no other destination (install, invite, …) applies. */
export function defaultAuthenticatedPath(
  user: { terms_accepted?: boolean } | null | undefined,
): string {
  return user && !user.terms_accepted ? '/tos' : '/projects'
}
